import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["onExited"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { useContext } from "react";
import { ModalContext } from "../ModalContext";
import { createElement as _createElement } from "react";
export function useModalState() {
  var _useContext = useContext(ModalContext),
      modals = _useContext.modals,
      removeModal = _useContext.removeModal;

  return modals.map(function (_ref, i) {
    var Modal = _ref.Modal,
        _ref$props = _ref.props,
        _onExited = _ref$props.onExited,
        rest = _objectWithoutProperties(_ref$props, _excluded);

    return /*#__PURE__*/_createElement(Modal, _objectSpread(_objectSpread({}, rest), {}, {
      key: i.toString(),
      onExited: function onExited() {
        _onExited == null ? void 0 : _onExited();
        removeModal(rest.name);
      }
    }));
  });
}